import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../../commons/functions';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import Favorites from '../../../../../../components/extras/Favorites';
import SidePanelMovement from '../../../../../../components/extras/SidePanelMovement';
import TableMovements from '../../../../../../components/tables/tableMovements';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../../resources/types';

const pageSize = 20;

export const MembersAccountsFuelPage = () => {
  //const storeAdmin = useStoreAdmin();

  const { menu, parameters, data } = useGlobalState();


  const [movements, setMovements] = useState<ItemsMovement[]>([]);
  const [movement, setMovement] = useState<Partial<ItemsMovement>>({});



  useEffect(() => {
    handleRefreshMovements();
  }, [parameters]); //parameters.startDate, parameters.endDate, 



  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) {
        handleGetMovement(parseInt(id))
      } else {
        setMovement(undefined)
        handleRefreshMovements();
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleGetMovement = async (idMovement: number) => {
    //if (parameters.startDate && parameters.endDate) { 
    if (parameters.year && parameters.month && data) {

      try {
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/user/movements/fuel/fuel',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(
            {
              idMovement: idMovement
            }
          ),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const dataWeb = await response.json();
        addNotificationStatus(dataWeb, setData);
        if (dataWeb.code == 0) {
          if (dataWeb.movement)
            setMovement(dataWeb.movement);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }

  const handleRefreshMovements = async () => {
    //if (parameters.startDate && parameters.endDate) { 
    if (parameters.year && parameters.month && data) {

      try {
        setMovements([]);
        setMovement(undefined);
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/user/movements/fuel/list',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(
            {
              orderBy: "dateTransaction",
              order: "desc",
              orderBy2: "idMovement",
              order2: "desc",
              year: parameters.year,
              month: parameters.month
            }
          ),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const dataWeb = await response.json();
        addNotificationStatus(dataWeb, setData);
        if (dataWeb.code == 0) {
          if (dataWeb.movements)
            setMovements(dataWeb.movements);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }
  return (
    <CustomAppLayout
      toolsHide
      splitPanelOpen={!!movement}
      onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = `members/accounts/statements/fuel` : null}
      splitPanel={
        <SidePanelMovement movement={movement ?? {}} />
      }

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween direction="vertical" size="xs">

            <Header actions={
              <SpaceBetween direction="horizontal" size="xs">

                <Favorites />
              </SpaceBetween>
            }
            >
              Cartola cuenta combustibles



            </Header>

            <TableMovements showUser={false} dateFilter='PERIOD' excel onSelect={(row) => {
              window.location.hash = `members/accounts/statements/fuel?id=${row.idMovement}`;
              //setMovement(row);
              //setDetailPanel(true)
            }} movements={movements} visible={true}
              onRangeChange={(startDate, endDate) => {

                const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                setParameters(updatedParameters);

              }}
            />

          </SpaceBetween>
        </>
      }
    />
  );
};
